import { FC, ReactNode } from 'react'
import styled from 'styled-components'

import { mediaMax } from 'styles/media'
import typeStyle from 'styles/typeStyle'

export const Heading = styled.h4`
  ${typeStyle('-ds-font-section-title-regular')}
  color: ${({ theme }) => theme['-ds-core-400'].value};
`

export const Text = styled.p`
  ${typeStyle('-ds-font-lead-sm-light')}
  color: ${({ theme }) => theme['-ds-core-300'].value};
`

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 30px;
  max-width: 485px;

  ${mediaMax.md`
    padding: 0;
  `}
`

type InfoParagraphProps = {
  heading: ReactNode
  text: ReactNode
}

const InfoParagraph: FC<InfoParagraphProps> = ({ heading, text }) => {
  return (
    <Inner>
      <Heading>{heading}</Heading>
      <Text>{text}</Text>
    </Inner>
  )
}

export default InfoParagraph
